import React, { Component } from "react";

export default class Step1 extends Component {
  constructor() {
    super();
    this.state = {};
  }

  toggleStepStatus = state => {
    switch (state) {
      case 0:
        return "step-disabled";
      case 1:
        return "step--current";
      case 2:
        return "step--completed";
      default:
        return;
    }
  };

  render() {
    let stepStatus = this.toggleStepStatus(this.props.appBarState1);
    let activateModal;
    this.props.appBarState1 === 2 &&
      (activateModal = this.props.modalWorkshopSearchToggle);
    this.props.showWorkshopSearchModal && (stepStatus = "step--edit");
    return (
      <div className="section-steps__step" onClick={activateModal}>
        <div className={`step ${stepStatus}`}>
          <div className="step__number">1</div>
          <div className="step__name">
            {this.props.selectedWorkshops ? (
              <div>
                <p style={{ marginBottom: 0 }}>{this.props.selectedWorkshops.DealershipName}</p>
                <p>{this.props.selectedWorkshops.DealershipAddress}</p>
              </div>
            ) : (
              "INSTALACIONES DISPONIBLES"
            )}
          </div>
          <div className="step__edit">
            <img src="./images/ico_edit.png" alt="editPen" />
          </div>
        </div>
      </div>
    );
  }
}
